import { NavLink, Outlet, Navigate, useLocation } from 'react-router-dom';
import { useCapabilities } from '../../hooks/useCapabilities.js';
import { clsx } from 'clsx';
import { KeyRound, Zap, Webhook, ScrollText, Tags, Users, LayoutTemplate, LayoutDashboard, Palette, Trash2, BookText, Globe2, Bell, Target } from 'lucide-react';

const SUB_NAV = [
  { to: '/admin', label: 'Access Control', icon: KeyRound, end: true },
  { to: '/admin/notifications', label: 'Notifications', icon: Bell, end: false },
  { to: '/admin/dashboard', label: 'Dashboard Builder', icon: LayoutDashboard, end: false },
  { to: '/admin/goals', label: 'Goals', icon: Target, end: false },
  { to: '/admin/automations', label: 'Automations', icon: Zap, end: false },
  { to: '/admin/webhooks', label: 'Webhooks', icon: Webhook, end: false },
  { to: '/admin/audit', label: 'Audit Log', icon: ScrollText, end: false },
  { to: '/admin/trash', label: 'Trash', icon: Trash2, end: false },
  { to: '/admin/tags', label: 'Tags', icon: Tags, end: false },
  { to: '/admin/templates', label: 'Compliance Templates', icon: LayoutTemplate, end: false },
  { to: '/admin/clauses', label: 'Clauses', icon: BookText, end: false },
  { to: '/admin/catalog', label: 'Engagement Templates', icon: Globe2, end: false },
  { to: '/admin/invoice-branding', label: 'Invoice Branding', icon: Palette, end: false },
  { to: '/admin/proposal-branding', label: 'Proposal Branding', icon: Palette, end: false },
  { to: '/team', label: 'Team', icon: Users, end: false },
];

export function AdminLayout() {
  const { canDo, isLoading } = useCapabilities();
  const location = useLocation();
  if (!isLoading && location.pathname.replace(/\/$/, '') === '/admin' && !canDo('admin.access')) return <Navigate to="/admin/templates" replace />;
  const visible = SUB_NAV.filter((item) => item.to === '/admin' || item.to === '/admin/trash' || item.to === '/admin/notifications' || item.to === '/admin/goals' ? canDo('admin.access') : item.to === '/admin/dashboard' ? canDo('dashboard.configure') : item.to === '/admin/audit' ? canDo('activity.view') : item.to === '/admin/invoice-branding' ? canDo('billing.view') : item.to === '/admin/proposal-branding' ? canDo('proposals.view') : true);
  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-xl font-semibold text-white">Admin Console</h1>
        <p className="text-sm text-muted">Firm controls — access, automations and integrations</p>
      </header>
      <div className="flex flex-col lg:flex-row gap-4 items-start">
        <nav className="w-full lg:w-52 shrink-0 bg-bg-panel border border-border rounded-xl p-2 flex flex-wrap lg:flex-col gap-1 shadow-panel">
          {visible.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => clsx(
                'flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-colors',
                isActive ? 'bg-bg-hover text-white' : 'text-muted hover:text-white hover:bg-bg-hover',
              )}
            >
              <item.icon size={15} className="shrink-0" />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex-1 min-w-0 w-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
